<!-- <p>create-cmms-case works!</p> -->

<app-dialog-header headerIcon="work" headerText="{{!editing ? 'Create New CMMS Case' : 'Edit CMMS Case'}}"
    (onCloseClick)="onCancelClick()"></app-dialog-header>

<div *ngIf="asset" class="asset-details">
    <span>Asset Name:</span>
    <span>{{asset.Name}}</span>
    <span>Asset Description:</span>
    <span>{{asset.Description}}</span>
    @if (asset.EquipmentCode) {
    <span>Asset EQ:</span>
    <span>{{asset.EquipmentCode}}</span>
    }
    @if (asset.FunctionalLocation) {
    <span>Asset FL:</span>
    <span>{{asset.FunctionalLocation}}</span>
    } @else if (asset.ParentFunctionalLocation) {
    <span>Asset FL:</span>
    <span>{{asset.ParentFunctionalLocation}}</span>
    }
    <ng-container *ngIf="parent">
        <span>Parent Location:</span>
        <span>{{parent.Name}}</span>
        <span>Parent FL:</span>
        <span>{{parent.FunctionalLocation}}</span>
    </ng-container>
</div>
<br>
<form [formGroup]="dialogForm">
    <div mat-dialog-content style="width: 600px; max-width: 800px;">
        <mat-form-field>
            <mat-label>Trigger Type</mat-label>
            <mat-select formControlName="TriggerType">
                <mat-option *ngFor="let trigger of triggerTypes"
                    [value]="trigger.TriggerType">{{trigger.Description}}</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Disable Rules</mat-label>
            <mat-select formControlName="RuleList" multiple (selectionChange)="onSelectionChange($event)">

                <!-- Select All option -->
                <mat-option [value]="'__all__'">Select All</mat-option>

                <mat-option *ngFor="let rule of Rules" [value]="rule.RuleID">
                    {{ rule.RuleDescription }}
                </mat-option>

            </mat-select>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Case Description</mat-label>
            <textarea matInput formControlName="Description" maxlength="1000"></textarea>
            <mat-hint align="end">{{ getCommentLength() }}/{{1000}}</mat-hint>
        </mat-form-field>
    </div>

    <div mat-dialog-actions>
        <button mat-button (click)="onDialogClose()" [disabled]="dialogForm.invalid || !dialogForm.dirty">Ok</button>
        <button *ngIf="!attachedToEvent" mat-button (click)="onCancelClick()" cdkFocusInitial>Cancel</button>
    </div>

</form>